import { Alert as NbAlert } from 'native-base';

import { addWithConfig } from '../../utils';

export const Alert = NbAlert;

export default addWithConfig(Alert);
